// What kind of file this is, by the `format` the API reports. Shared by the preview (which
// loader to run) and the lists (which icon to draw), so it lives outside both.

const IMAGE_FORMATS = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg']);
const TABLE_FORMATS = new Set(['xlsx', 'xls', 'xlsm', 'csv']);

export function isImageFile(file) {
  return IMAGE_FORMATS.has((file?.format || '').toLowerCase());
}

export function isTableFile(file) {
  return TABLE_FORMATS.has((file?.format || '').toLowerCase());
}

export function isPdfFile(file) {
  return (file?.format || '').toLowerCase() === 'pdf';
}

// A file the backend is still working on. Narrow on purpose: real statuses include terminal
// ones like `completed`, `mapped`, `waiting for mapping`, `failed` — matching loosely (e.g. on
// "upload") would catch "uploaded" and poll forever. Only "processing" / "in progress" are
// genuinely transient.
export function isFileInProgress(file) {
  return /process|in.?progress/i.test(file?.status || '');
}

/* The state between "read" and "usable": the bytes are in, the sheets are known, and the backend is
   still deciding which previous-period file and which categories this one answers to. It is the
   window the board reads wrong — the file is listed, its pairing is not written yet — and
   `isFileInProgress` deliberately treats it as terminal, so it needs saying separately. It can also
   simply stay this way, on a file nobody ever maps, which is why it reads as a fact about the file
   rather than as a promise that something is running. */
export function isAwaitingMapping(file) {
  return /waiting.*mapping/i.test(file?.status || '');
}

export function formatFileSize(bytes) {
  if (!bytes) return null;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
